import { createClient } from "@connectrpc/connect";
import { ISaveService } from "../../../abstractions/services/actions/ISaveService";
import { grpcTransportProvider } from "../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../comun/services/grpc/mapConnectError";
import { AplicacionRecipienteService } from "../../../generated/grpc/aplicaciones_pb";
import { grpcAplicacionRecipienteDatabase } from "../database/GrpcAplicacionRecipienteDatabase";
import { AplicacionRecipienteRequest } from "../request/AplicacionRecipienteRequest";
import { AplicacionRecipienteResponse } from "../response/AplicacionRecipienteResponse";
import {
  fx_createAplicacionRecipienteGrpcService,
  toAplicacionRecipienteResponse,
} from "./AplicacionRecipienteGrpcService";

/** Alta/edición de un recipiente (`id` ausente = crear). Persiste el guardado e
 *  invalida el cooldown del listado del cliente, mismo criterio que
 *  `TareaSaveGrpcService`: sin eso la lista recién guardada podía volver a
 *  leerse del cooldown y mostrarse sin el cambio. */
export class AplicacionRecipienteSaveGrpcService
  implements
    ISaveService<AplicacionRecipienteRequest, AplicacionRecipienteResponse>
{
  async saveAsync(
    request: AplicacionRecipienteRequest,
  ): Promise<AplicacionRecipienteResponse> {
    const client = createClient(
      AplicacionRecipienteService,
      grpcTransportProvider.get(),
    );

    let saved;
    try {
      saved = await client.guardar({
        id: request.id ?? undefined,
        clienteId: request.clienteId,
        nombre: request.nombre,
        litros: request.litros,
      });
    } catch (error) {
      throw mapConnectError(error);
    }

    await grpcAplicacionRecipienteDatabase.putOneAsync(saved);
    fx_createAplicacionRecipienteGrpcService(saved.clienteId).clearCache();
    return toAplicacionRecipienteResponse(saved);
  }
}

/** Instancia única del servicio de guardado de recipientes. */
export const aplicacionRecipienteSaveGrpcService =
  new AplicacionRecipienteSaveGrpcService();
